import { SortKeys } from '@chegg-wt/core/constants/projects'
import { Reducer } from 'redux'
import { CitationValidityVariations } from '../../types/core'
import { ActionTypes } from './constants'
import { BibliographyState } from './types'

export const initialState: BibliographyState = {
  isFetching: false,
  sortKey: SortKeys.ALPHABETICAL,
  citations: [],
  page: 1,
  citationValidityVariation: CitationValidityVariations.CONTROL,
}

export const bibliographyReducer: Reducer<BibliographyState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ActionTypes.DELETE_CITATIONS:
      return {
        ...state,
        isDeleting: true,
      }
    case ActionTypes.DELETE_CITATIONS_SUCCEEDED:
    case ActionTypes.DELETE_CITATIONS_FAILED:
      return {
        ...state,
        isDeleting: false,
      }
    case ActionTypes.ADD_CITATIONS:
      return {
        ...state,
        isAdding: true,
      }
    case ActionTypes.ADD_CITATIONS_SUCCEEDED:
    case ActionTypes.ADD_CITATIONS_FAILED:
      return {
        ...state,
        isAdding: false,
      }
    case ActionTypes.FETCH_CITATIONS:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.FETCH_CITATIONS_SUCCEEDED:
      return {
        ...state,
        isFetching: false,
        citations: action.payload.citations,
      }
    case ActionTypes.FETCH_CITATIONS_FAILED:
      return {
        ...state,
        isFetching: false,
      }
    case ActionTypes.FETCH_NOTES_SUCCEEDED:
      return {
        ...state,
        citations: action.payload.citations,
      }
    case ActionTypes.SET_CITATION_VALIDITY_VARIATION:
      return {
        ...state,
        citationValidityVariation: action.payload.citationValidityVariation,
      }
    case ActionTypes.SORT_CITATIONS:
      return {
        ...state,
        sortKey: action.payload.sortKey,
      }
    case ActionTypes.TOGGLE_CITATION_CHECKBOX:
      return {
        ...state,
        citations: state.citations.map((citation) =>
          citation.id === action.payload.citationId
            ? { ...citation, selected: !citation.selected }
            : citation
        ),
      }
    case ActionTypes.SELECT_ALL_CITATIONS:
      return {
        ...state,
        citations: state.citations.map((citation) => ({ ...citation, selected: true })),
      }
    case ActionTypes.DESELECT_ALL_CITATIONS:
      return {
        ...state,
        citations: state.citations.map((citation) => ({ ...citation, selected: false })),
      }
    case ActionTypes.SET_CITATIONS_PAGE:
      return {
        ...state,
        page: action.payload.page,
      }
    default:
      return state
  }
}

export default bibliographyReducer
